// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { autocompleteProductsStyles } from "@tps/Overrides/Widgets/Header/AutocompleteProducts";
import { color, ellipsis, styledScrollbar, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

autocompleteProductsStyles.headerText = {
    color: "text",
    weight: "bold",
    size: 14,
    css: css`
        text-align: left;
        margin: 13px 0 8px;
        display: block;
    `,
};

autocompleteProductsStyles.container = {
    gap: 0,
    css: css`
        flex-grow: 0;
        margin: 0;
        cursor: pointer;
        padding-bottom: 12px;
        &:not(:last-child) {
            margin-bottom: 12px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 92px;
        height: 80px;
        flex-basis: 92px;
    `,
};

autocompleteProductsStyles.imageBadgeGridItem = {
    css: css`
        max-width: 80px;
        flex-basis: 80px;
    `,
};

autocompleteProductsStyles.image = {
    width: "80px",
    css: css`
        img {
            height: auto;
            object-fit: contain;
        }
    `,
};

autocompleteProductsStyles.infoGridItem = {
    width: 9,
    css: css`
        flex-direction: column;
        max-width: calc(100% - 92px);
        flex-basis: calc(100% - 92px);
    `,
};

autocompleteProductsStyles.titleLink = {
    typographyProps: {
        size: 14,
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;
            ${ellipsis(2)}
            &&& {
                color: ${color("text")};
            }
        `,
    },
    css: css`
        max-width: 100%;
    `,
};

autocompleteProductsStyles.wrapper = {
    css: css`
        max-height: 100%;
        padding-right: 12px;
        ${styledScrollbar(4)};
        ${xScreen("lte", "md")} {
            padding-right: 37px;
        }
        ${xScreen("lte", "sm")} {
            padding-right: 16px;
        }
    `
};